<template>
  <div class="marginBT">
    <div class="marginLR center titlesContainer">
      <h2 class="titles">
        {{ $t("datos.grandesCuentas.operacion.alta.resumen.titulo") }}
      </h2>
      <p class="subtitles">
        {{ $t("datos.grandesCuentas.operacion.alta.resumen.subtitulo") }}
      </p>
    </div>

    <div class="whitePanel marginBottom">
      <Errors
        v-if="this.errors && this.errors.length > 0"
        :errors="this.errors"
      />

      <div class="grid marginB5Px">
        <div class="col-6">
          <p>
            <strong
              >{{
                $t(
                  "datos.grandesCuentas.operacion.alta.resumen.campos.cliente"
                )
              }}:</strong
            >
            {{
              operacion.carteraUsuario.cliente.idLegal +
              " - " +
              getFullName(
                operacion.carteraUsuario.cliente.nombre,
                operacion.carteraUsuario.cliente.apellidos,
                null
              )
            }}
          </p>
          <p>
            <strong
              >{{
                $t(
                  "datos.grandesCuentas.operacion.alta.resumen.campos.acreedor"
                )
              }}:</strong
            >
            {{
              operacion.datosAcreedor.idLegal +
              " - " +
              getFullName(
                operacion.datosAcreedor.nombre,
                operacion.datosAcreedor.apellidos,
                null
              )
            }}
          </p>
          <p>
            <strong
              >{{
                $t("datos.grandesCuentas.operacion.alta.resumen.campos.deudor")
              }}:</strong
            >
            {{
              operacion.datosDeudor.idLegal +
              " - " +
              getFullName(
                operacion.datosDeudor.nombre,
                operacion.datosDeudor.apellidos,
                null
              )
            }}
          </p>
        </div>
        <div class="col-6">
          <p>
            <strong
              >{{
                $t(
                  "datos.grandesCuentas.operacion.alta.resumen.campos.cartera"
                )
              }}:</strong
            >
            {{ operacion.carteraUsuario.nombre }}
          </p>
          <p>
            <strong
              >{{
                $t(
                  "datos.grandesCuentas.operacion.alta.resumen.campos.origenDeuda"
                )
              }}:</strong
            >
            {{ operacion.literalOrigenDeuda }}
          </p>
          <p
            v-if="
              operacion.ficherosMorosidad &&
              operacion.ficherosMorosidad.filter((fm) => fm).length > 0"
          >
            <strong>{{$t("datos.grandesCuentas.operacion.alta.resumen.campos.ficherosMorosidad")}}:</strong
            >
            {{ operacion.ficherosMorosidad.join(", ") }}
          </p>
        </div>
      </div>
      <div class="grid p-fluid p-formgrid">
        <div class="col-12 p-field">
          <label for="iban-recuperacion"
            ><strong>{{
              $t("datos.grandesCuentas.operacion.alta.resumen.campos.iban")
            }}</strong></label
          >
          <InputText
            :disabled="Boolean(operacion.carteraUsuario.iban)"
            v-if="Boolean(operacion.carteraUsuario.iban)"
            class="input"
            id="iban-recuperacion"
            type="text"
            v-model="operacion.carteraUsuario.iban"
            :placeholder="
              $t(
                'datos.grandesCuentas.operacion.alta.resumen.placeholders.iban'
              )"
          />
          <InputText
            v-else
            class="input"
            id="iban-recuperacion"
            type="text"
            v-model="operacion.iban"
            :placeholder="
              $t(
                'datos.grandesCuentas.operacion.alta.resumen.placeholders.iban'
              )"
          />
        </div>
      </div>
      <div class="grid p-fluid p-formgrid">
        <div class="col-12 md:col-12 p-field">
          <h1>Añadir Impagos</h1>
        </div>
        <div class="grid p-fluid p-formgrid">
        <div class="col-12 md:col-4 p-field">
          <label for="fechaPago">
            <strong>{{ $t("operacion.impagos.fechaVencimiento") }}</strong>
          </label>
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <em class="pi pi-calendar"></em>
            </span>
            <Calendar
              id="icon"
              v-model="impago.fechaVencimiento"
              dateFormat="dd/mm/yy"
              :showIcon="true"
              :showTime="false"
              :locale="getLocale"
            />
          </div>
        </div>

        <div class="col-12 md:col-4 p-field">
          <label for="importe">
            <strong>{{ $t("operacion.impagos.importe") }}</strong></label
          >
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <em class="pi pi-money-bill"></em>
            </span>
            <InputNumber
              id="importe"
              :min="0.01"
              @paste="this.onImportPasteEvent"
              v-model="impago.importe"
              mode="decimal"
              :maxFractionDigits="2"
              :placeholder="$t('operacion.pagosCuenta.placeHolders.importe')"
              @blur="enviaImporte(impago.importe)"
            />
          </div>
        </div>

        <div class="col-12 md:col-4 p-field">
          <label for="referenciaCliente"
            ><strong>{{ $t("operacion.impagos.referenciaCliente") }}</strong></label
          >
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <em class="pi pi-id-card"></em>
            </span>
            <InputText
              class="input"
              id="referenciaCliente"
              type="text"
              v-model="impago.referenciaCliente"
              :placeholder="
                $t('operacion.pagosCuenta.placeHolders.referenciaCliente2')"
            />
          </div>
        </div>
        <div class="col-12 md:col-12 p-field">
          <Segmento 
            nivel="IMPAGO" 
            ref="segmento"
            :carteraUsuario="this.operacion.carteraUsuario"
            :contrato="this.operacion.producto.contrato"
            :tipoEntidad="this.datosOperacion.datosDeudor.tipoEntidad">
          </Segmento>
        </div>
       </div>
        
        <div class="col-12 md:col-4 p-field">
          <Button
            @click.prevent="addImpago()"
            :label="'Introducir Impago'"
            icon="pi pi-save"
            iconPos="left"
          />
        </div>
        <div class="col-12 md:col-12 p-field">
          <h1>Impagos</h1>
        </div>
        <div class="col-12 md:col-12 p-field">
          <DataTable
            :value="operacion.impagos"
            :header="$t('expedientes.header.reclamacion')"
            class="p-datatable-responsive expendientesDataTable"
          >
            <Column
              field="fechaVencimiento"
              :header="$t('expedientes.header.fecha')"
              :sortable="true"
              :headerStyle="headerStyle"
            >
              <template #body="slotProps">
                <span class="p-column-title">{{
                  $t("expedientes.label.fecha")
                }}</span>
                {{ getFormattedDateShort(slotProps.data.fechaVencimiento) }}
              </template>
            </Column>
            <Column
              field="importe"
              :header="$t('expedientes.header.pendiente')"
              :sortable="false"
              :headerStyle="headerStyle"
            >
              <template #body="slotProps">
                <span class="p-column-title">{{
                  $t("expedientes.label.pendiente")
                }}</span>
                {{
                  slotProps.data.importe
                    | toCurrency("es-ES", slotProps.data.divisa)
                }}
              </template>
            </Column>
            <Column
              field="referenciaCliente"
              :header="$t('expedientes.header.referenciaCliente')"
              :sortable="false"
              :headerStyle="headerStyle"
            >
              <template #body="slotProps">
                <span class="p-column-title">{{
                  $t("expedientes.label.estado")
                }}</span>
                {{ slotProps.data.referenciaCliente }}
              </template>
            </Column>
            <Column
              :header="$t('expedientes.header.acciones')"
              headerStyle="width: 80px"
              bodyStyle="text-align: center"
            >
              <template #body="slotProps">
                <Button
                  type="button"
                  icon="pi pi-pencil"
                  class="p-button-warning"
                  style="margin-right: 0.5em"
                  @click="onEditImpago(slotProps.index)"
                ></Button>
                <Button
                  type="button"
                  icon="pi pi-trash"
                  class="p-button-danger"
                  style="margin-right: 0.5em"
                  @click="onDeleteImpago(slotProps.index)"
                ></Button>
              </template>
            </Column>
          </DataTable>
        </div>
        <div class="col-12 md:col-12 p-field">
          <h1>Documentación</h1>
        </div>
        <div class="col-12 md:col-4 p-field">
          <input
            ref="upload"
            type="file"
            v-show="false"
            @change="onFileChange"
            multiple
          />
          <Button
            :label="'Subir Documentación'"
            @click="openDocumentSelector"
            icon="pi pi-upload"
            iconPos="left"
          />
        </div>
        <div class="file-list">
          <div v-for="file in files" :key="file.filename">
            <span
              class="cursorPointer"
              @click="
                [
                  removeArrayElement(files, file),
                  removeArrayBeforeConversionElement(
                    filesBeforeConversion,
                    file
                  ),
                  resetInputFile(),
                ]"
            >
              <em class="pi pi-times iconSize buttonIcon" />
            </span>
            <span class="file-text">{{ file.filename }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_SEGMENTO } from "@/graphQLQueries/SegmentosQueries";
import { GET_LISTA_CARTERAS } from "@/graphQLQueries/CarterasQueries";

import MessagesMixin from "@/utils/messages";
import Errors from "@/components/utilidades/Errors.vue";
import StringsMixin from "@/utils/strings";
import DatesMixin from "@/utils/dates";
import FilesMixin from "@/utils/files";
import CurrencyMixin from "@/utils/currency";
import IbanMixin from "@/utils/iban";
import Segmento from "./Segmentos/Segmento"

export default {
  name: "ResumenOperacion",
  mixins: [
    MessagesMixin,
    StringsMixin,
    DatesMixin,
    CurrencyMixin,
    IbanMixin,
    FilesMixin,
  ],
  props: {
    datosOperacion: {
      type: Object,
      required: true,
    },
    erroresAltaOperacion: {
      type: Array,
      required: true,
    },
  },
  components: {
    Errors,
    Segmento
  },
  data() {
    return {
      errors: this.erroresAltaOperacion,
      operacion: this.datosOperacion,
      impagos: [],
      impago: {
        fechaVencimiento: null,
        importe: null,
        referenciaCliente: null,
        jsonSegmento: null
      },
      headerStyle: "",
      files: [],
      filesBeforeConversion: [],
      segmento: null,
      atributosNullable: false
    };
  },
  created(){
    this.obtenerCartera()
    this.getSegmento()
  },
  methods: {
    getSegmento(){
      let carteraUsuario = this.operacion.carteraUsuario
      if (carteraUsuario != null && carteraUsuario.segmento){
        this.$apollo.query({
            query: GET_SEGMENTO,
            variables: {
              idSegmento: carteraUsuario.segmento.id
            },
          })
          .then((data) => {
            this.segmento = data.data.segmento
            let atributos = this.segmento ? this.segmento.atributos : null;
            for (const element of atributos) {
              if((element.nivel === 'IMPAGO') && (element.nullable))
                this.atributosNullable = true
            }
          })
          .catch((exception) => {
            this.errors = [];
            exception.graphQLErrors.forEach((error) => {
              this.errors.push(error.message);
            });
          });
      }
      else
        this.segmento = null
    },
    obtenerCartera() {
        if(this.carteraUsuario) {
          this.$apollo
            .query({
              query: GET_LISTA_CARTERAS,
              variables: {
                filter: [
                  `id~eq=${this.operacion.carteraUsuario.id}`,
                ],
                page: 0,
                size: 1,
              },
              fetchPolicy: "no-cache",
            })
            .then((data) => {
              this.operacion.carteraUsuario.segmento.id = data.data.listadoCarteras.results[0].segmento.id
            }).catch((exception) => {
              console.log(exception)
            });
        }
      },
    getJsonImpago(){
      let json = this.$refs.segmento.getJsonSegmento();
      if (json != null)   return json;
      return "";
    },  
    addImpago() {
      const jsonImpago=this.getJsonImpago()
      let valido = true;
      this.errors = [];
      if (this.segmento){
        this.validateAtributo();
        this.impago.jsonSegmento=jsonImpago;
      }
      if(this.errors.length == 0) {
        if (this.impago.importe == null || this.impago.importe < 0) {
          this.errors.push("Importe no valido");
          valido = false;
        }
        if (
          this.impago.referenciaCliente == null ||
          this.impago.referenciaCliente === ""
        ) {
          this.errors.push(this.$t("operacion.impagos.errores.9999999"));
          valido = false;
        }
        const now = new Date();
        now.setHours(0, 0, 0, 0);

        const years =
          "deudorEntidad" == this.datosOperacion.datosDeudor.tipoEntidad ? 10 : 5;
        const limit = new Date(
          now.getFullYear() - years,
          now.getMonth(),
          now.getDate()
        );

        if (this.impago.fechaVencimiento == null) {
          this.errors.push("Introduzca una fecha de vencimiento");
          valido = false;
        } else if (this.impago.fechaVencimiento >= now) {
          this.errors.push(this.$t("operacion.impagos.errores.9999998"));
          valido = false;
        } else if (this.impago.fechaVencimiento < limit) {
          this.errors.push(this.$t("operacion.impagos.errores.9999997"));
          valido = false;
        }
        if (valido) {
          this.operacion.impagos.push(this.impago);
          this.impago = {
            fechaVencimiento: null,
            importe: null,
            referenciaCliente: null,
            jsonSegmento: null
          };
          this.$refs.segmento.limpiaValores()
        } else {
          window.scrollTo(0, 0);
        }
      } else {
        window.scrollTo(0, 0);
      }
    },
    onEditImpago(index) {
      const impago = this.operacion.impagos[index];

      this.impago = { ...impago };
      this.$refs.segmento.editImpago(this.impago)
      this.onDeleteImpago(index);
    },
    onDeleteImpago(index) {
      this.operacion.impagos.splice(index, 1);
    },
    validateOperacion() {
      this.errors = [];
      this.validateIbanCartera();
      this.validateImporteOperacion();
    },
    validateIbanCartera() {
      if (this.operacion.carteraUsuario.iban) return;

      if (!this.operacion.iban)
        this.errors.push(
          this.$t(
            "datos.grandesCuentas.operacion.alta.resumen.errores.ibanObligatorio"
          )
        );
      else if (!this.isValidIBANNumber(this.operacion.iban))
        this.errors.push(
          this.$t("datos.grandesCuentas.operacion.alta.resumen.errores.importe")
        );
    },
    validateImporteOperacion() {
      const importe = this.operacion.impagos.reduce(
        (sum, cur) => parseFloat(sum) + parseFloat(cur.importe),
        0
      );
      
      let minImporte = this.operacion.producto.contrato.limiteOperacionPPJJ;
      minImporte = minImporte ? minImporte : 50;

      if (this.operacion.datosDeudor.tipoSociedad == "deudorParticular" || this.operacion.datosDeudor.tipoSociedad == "deudorAutonomo" ||
        this.operacion.datosDeudor.tipoEntidad == "deudorParticular" || this.operacion.datosDeudor.tipoEntidad == "deudorAutonomo")
        minImporte = this.operacion.producto.contrato.limiteOperacionPPFF;

      if (importe >= minImporte) return;
      this.errors.push(
        this.$t(
          "datos.grandesCuentas.operacion.alta.resumen.errores.importeInferiorAlMinimo", {
            cantidad: minImporte
          }
        )
      );
    },
    validateAtributo(){
      this.errors = this.$refs.segmento.getErrors();
    },
    hasOperacionErrors() {
      return this.errors.length > 0;
    },
    onImportPasteEvent(event) {
      event.preventDefault();
      this.impago.importe = Number(
        event.clipboardData.getData("text").replace(/\./g, "").replace(",", ".")
      );
    },
    openDocumentSelector() {
      this.$refs.upload.click();
    },
    async onFileChange(e) {
      const seen = new Set();
      let arrayFiles = this.filesBeforeConversion.concat(
        Array.from(e.target.files)
      );
      const filteredArr = arrayFiles.filter((el) => {
        const duplicate = seen.has(el.name);
        seen.add(el.name);
        return !duplicate;
      });
      this.filesBeforeConversion = filteredArr;
      this.files = await this.convertFiles(this.filesBeforeConversion);
    },
    removeArrayElement(list, value) {
      const idx = list.indexOf(value);

      if (idx !== -1) {
        list.splice(idx, 1);
      }
    },
    removeArrayBeforeConversionElement(list, value) {
      const listFiltered = list.filter((file) => file.name != value.filename);
      this.filesBeforeConversion = listFiltered;
    },
    resetInputFile() {
      this.$refs.upload.value = null;
    },
    enviaImporte(importe) {
      this.$refs.segmento.getImporte(importe);
    },
  },
  watch: {
    erroresAltaOperacion(newValue) {
      this.errors.splice(0, this.errors.length, ...newValue);
    },
  },
  computed: {
    getLocale() {
      return this.$i18n.t("calendar");
    },
  },
};
</script>

<style lang="scss" scoped>
.titlesContainer {
  padding-bottom: 1.25em !important;
}

.file-list span {
  vertical-align: top;
}

.file-list .file-text {
  vertical-align: middle;
}

.cursorPointer:hover {
  cursor: pointer;
}

 legend {
  font-weight: bold;
 }

</style>